<div class="sidebar" [class.sidebar__active]="showSidebar">
  <div class="sidebar__container">
    <div class="sidebar__container__link">
      <a href="https://www.moneytrans.eu/belgium/es/about-us/" target="_blank">
        {{ 'P_ABOUT_US' | translate }}
      </a>
    </div>

    <div class="sidebar__container__link">
      <a href="https://www.moneytrans.eu/moneytransblog/en/" target="_blank">
        {{ 'Blog' | translate }}
      </a>
    </div>

    <div class="sidebar__container__link">
      <a [href]="translate.currentLang | termsPipe" target="_blank">
        {{ 'M_PAC_ENROLLMENT_TERMS_AND_CONDITIONS_TITLE' | translate }}
      </a>
    </div>

    <div class="sidebar__container__link">
      <a [href]="translate.currentLang | privacyPolicyPipe" target="_blank">
        {{ 'C_F_PRIVACY_POLICY' | translate }}
      </a>
    </div>

    <div class="sidebar__container__link">
      <a [href]="translate.currentLang | cookiesPolicyPipe" target="_blank">
        {{ 'C_F_COOKIES_POLICY' | translate }}
      </a>
    </div>

    <div class="sidebar__container__link" (click)="logOut()">
      <a class="sidebar__container__link__highlight">
        {{ 'C_A_LOGOUT' | translate }}
      </a>
      <img alt="log out" src="assets/images/icons/navbar/logout.png" />
    </div>
  </div>
</div>
